export default "__VITE_ASSET__BJNdgqxz__"